module.exports = __webpack_public_path__ + "img/aboutfrom.0d952ee8.png";